import { useEmmaJS } from './useEmmaJS';
import { useEffect } from 'react';

export const useOverrideCloseEvent = ({
  enable = true,
  callback,
}: {
  enable?: boolean;
  callback?: () => void;
}) => {
  const EmmaJs = useEmmaJS();

  useEffect(() => {
    if (!EmmaJs?.instance) return;
    if (enable) {
      EmmaJs?.instance?.overrideCloseEvent?.();
    } else {
      EmmaJs?.instance?.resetCloseEvent?.();
    }
  }, [EmmaJs, enable]);

  useEffect(() => {
    const handleMessage = (e) => {
      const closeEvent =
        e?.detail?.action === 'EMMA_WEBVIEW_POST_MSG' &&
        e?.detail?.payload?.type === 'CLOSE_EVENT';

      if (closeEvent) callback?.();
    };
    document.addEventListener('reactNativeMessage', handleMessage);
    return () => {
      document.removeEventListener('reactNativeMessage', handleMessage);
    };
  }, [callback]);
};

export default useOverrideCloseEvent;
